import { render, staticRenderFns } from "./CitySunParallax.vue?vue&type=template&id=fb748b00"
import script from "./CitySunParallax.vue?vue&type=script&lang=js"
export * from "./CitySunParallax.vue?vue&type=script&lang=js"
import style0 from "./CitySunParallax.vue?vue&type=style&index=0&id=fb748b00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports